export const plural = (
  number: number,
  singular: string,
  few: string,
  many: string,
) => {
  if (number % 10 === 1 && number % 100 !== 11) {
    return singular;
  } else if (
    [2, 3, 4].includes(number % 10) &&
    ![12, 13, 14].includes(number % 100)
  ) {
    return few;
  } else {
    return many;
  }
};
